import React from 'react';
import castArray from 'lodash/castArray';

import PageNotFound from './PageNotFound.jsx';
import PageErr from './PageErr.jsx';
import AnimPending from './AnimPending.jsx';

const PageHttp = ({
  children,
  className,
  res,
}) => {
  let status = 'pending';
  let code;
  const responses = castArray(res);
  const err = responses.find((r) => r.status === 'error');

  if (err) {
    status = 'error';
    code = err.code;
  }
  if (responses.every((r) => r.status === 'success')) {
    status = 'success';
  }

  return (
    <div className={className}>
      {status === 'pending' && (
        <AnimPending vAlign />
      )}
      {status === 'error' && (
        code === 404 ? (
          <PageNotFound vAlign />
        ) : (
          <PageErr vAlign />
        )
      )}
      {(status === 'success') && children(
        Array.isArray(res) ? res.map((r) => r.payload) : res.payload,
      )}
    </div>
  );
};

export default PageHttp;
